import { render, staticRenderFns } from "./ReceiptComponent.vue?vue&type=template&id=68715349&"
import script from "./ReceiptComponent.vue?vue&type=script&lang=js&"
export * from "./ReceiptComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports